"use client";

import React from 'react';
import { Play, ArrowRight, Zap } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Link } from '@/components/common/Link';
import { useRevealOnScroll } from '@/hooks/useRevealOnScroll';
export default function AccelerateYourVision() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="accelerate-your-vision" ref={ref} className="dark bg-background text-foreground relative w-full overflow-hidden py-20 lg:py-32">
      {}
      <div className="absolute inset-0 z-0 pointer-events-none">
        <div className="absolute inset-0 bg-[linear-gradient(to_right,rgba(148,163,184,0.55)_1px,transparent_1px),linear-gradient(to_bottom,rgba(148,163,184,0.55)_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_50%,#000_70%,transparent_100%)] opacity-[0.03] animate-pulse" style={{
        animationDuration: "4s"
      }} />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
          
          {}
          <div className={`w-full lg:w-[60%] space-y-8 transition-all duration-1000 ease-out transform ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-10'}`}>
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/10 border border-primary/20 backdrop-blur-sm">
              <Zap className="w-4 h-4 text-primary" />
              <span className="font-mono text-sm font-bold tracking-widest text-primary uppercase">Wir schmieden die Zukunft</span>
            </div>

            <h1 className="font-sans text-5xl md:text-7xl lg:text-[5rem] font-bold leading-[1.1] tracking-tight"><span className="bg-gradient-to-b from-white via-slate-200 to-slate-500 bg-clip-text text-transparent" data-ast-id="f:/src/pages/Home/sections/AccelerateYourVision.tsx|sig:aqgrkw" data-ast-start="1801" data-ast-end="2059" style={{}}>Beschleunige<br /></span>Deine Vision<br /></h1>

            <p className="text-lg md:text-xl text-muted-foreground max-w-2xl leading-relaxed">Wir nutzen künstliche Intelligenz, um hochwertige visuelle Inhalte und Lernmaterialien für kleine und mittelständische Kunden zu erstellen. Skaliere mit uns Deine Medienproduktion zu unschlagbar günstigen Preisen.</p>

            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <Button asChild size="lg" className="h-14 px-8 text-base font-semibold rounded-full shadow-[0_0_20px_-5px_var(--color-primary)] hover:shadow-[0_0_30px_-5px_var(--color-primary)] transition-all duration-300">
                <Link to="/ContactPage">Kontaktiere uns<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-arrow-right ml-2 w-5 h-5" aria-hidden="true" data-ast-id="f:/src/pages/Home/sections/AccelerateYourVision.tsx|sig:cqcyhu" data-ast-start="2753" data-ast-end="2792"><path d="M5 12h14"></path><path d="m12 5 7 7-7 7"></path></svg></Link>
              </Button>
              
              {/*
               <Button asChild variant="outline" size="lg" className="h-14 px-8 text-base font-semibold rounded-full border-slate-700 hover:bg-slate-800/50 hover:text-white transition-all">
                <Link to="#demo-reel">
                  <Play className="mr-2 w-5 h-5 fill-current" />
                  Watch Reel
                </Link>
               </Button>
               */}
            </div>
          </div>

          {}
          <div className={`w-full lg:w-[40%] flex justify-center lg:justify-end transition-all duration-1000 delay-300 ease-out transform ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-20'}`}>
            <style dangerouslySetInnerHTML={{
            __html: `
              @keyframes subtle-bounce {
                0%, 100% { transform: translateY(0); animation-timing-function: cubic-bezier(0.8, 0, 1, 1); }
                50% { transform: translateY(-2.5%); animation-timing-function: cubic-bezier(0, 0, 0.2, 1); }
              }
            `
          }} />
            <div className="relative w-full max-w-4xl aspect-[16/9] group">
              {}
              <div className="w-full h-full">
                {}
                <div className="relative w-full h-full rounded-[40px] overflow-hidden border border-white/10 shadow-2xl bg-slate-900">
                  
                  {}
                  <div className="absolute -inset-4 bg-primary/20 blur-3xl -z-10 rounded-full opacity-50 transition-opacity duration-500" />

                  {}
   <div className="relative w-full h-full">
  <video className="absolute -inset-px w-[calc(100%+2px)] h-[calc(100%+2px)] object-cover" src="https://just-shepherd.10web.cloud/wp-content/uploads/2026/02/Showreel_SD.mp4" autoPlay muted loop playsInline preload="metadata" />
</div>

                  {}
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-black/20 pointer-events-none" />

                  {}
                  <div className="absolute bottom-8 left-1/2 -translate-x-1/2 w-max transition-opacity duration-300">
                    <div className="px-4 py-2 rounded-full bg-white/10 backdrop-blur-md border border-white/20 text-xs font-mono text-white/90 flex items-center gap-2">
                      <div className="w-2 h-2 rounded-full bg-green-500 animate-pulse" />
                      AI GENERATING...
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}